module.exports = __webpack_public_path__ + "img/professionalProjectManagementTeam.83699c64.svg";